<template>
  <div id="gallery">
    <FileUpload
      :dialog.sync="uploadDialog"
      :multiple="true"
      :uploadProgress="uploadProgress"
      @filesUploaded="processUpload($event)"
    />
    <v-container :fluid="$store.state.experiments['EXPERIENCE_FLUID']">
      <v-row v-if="!$vuetify.breakpoint.mobile && !loading">
        <v-col md="7">
          <v-text-field
            class="rounded-xl"
            v-model="show.search"
            :outlined="!$store.state.site.whitelabel"
            v-shortkey.avoid
            append-icon="mdi-close"
            label="Search"
            @click:append="
              show.search = ''
              getItems(true, true)
            "
            v-on:keyup.enter="getItems(true, true)"
          ></v-text-field>
        </v-col>
        <v-col md="2">
          <v-select
            v-model="show.selected"
            :items="show.types"
            :outlined="!$store.state.site.whitelabel"
            item-text="name"
            item-value="internalName"
            label="Filter"
            v-on:change="getItems(true, false)"
          ></v-select>
        </v-col>
        <v-col md="2">
          <v-checkbox
            label="Search in files (metadata)"
            v-model="show.metadata"
            v-shortkey.avoid
          >
          </v-checkbox>
        </v-col>
        <v-col md="1">
          <div class="pt-3">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="rounded-xl" block v-bind="attrs" v-on="on">
                  Create</v-btn
                >
              </template>
              <v-list>
                <v-list-item
                  style="cursor: pointer"
                  @click="uploadDialog = true"
                >
                  <v-list-item-title>Upload File</v-list-item-title>
                </v-list-item>
                <v-list-item
                  style="cursor: pointer"
                  @click="$router.push('/pastes/create')"
                >
                  <v-list-item-title>Create Paste</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-col>
      </v-row>
      <div v-else-if="!loading">
        <v-text-field
          class="rounded-xl"
          v-model="show.search"
          :outlined="!$store.state.site.whitelabel"
          append-icon="mdi-magnify"
          label="Search"
          @click:append="getItems(true, true)"
          v-on:keyup.enter="getItems(true, true)"
        ></v-text-field>
        <v-select
          v-model="show.selected"
          :items="show.types"
          :outlined="!$store.state.site.whitelabel"
          item-text="name"
          item-value="internalName"
          label="Filter"
          v-on:change="getItems(true, false)"
        ></v-select>
        <v-checkbox
          class="mt-n3"
          label="Search in files (metadata)"
          v-model="show.metadata"
        >
        </v-checkbox>
        <div class="mt-n3 mb-3">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="rounded-xl" block v-bind="attrs" v-on="on">
                Create</v-btn
              >
            </template>
            <v-list>
              <v-list-item style="cursor: pointer" @click="uploadDialog = true">
                <v-list-item-title>Upload File</v-list-item-title>
              </v-list-item>
              <v-list-item
                style="cursor: pointer"
                @click="$router.push('/pastes/create')"
              >
                <v-list-item-title>Create Paste</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
      <GalleryNext
        :items="items"
        :selected="selected"
        :set-page="setPage"
        :page-value="page"
        :getItems="getItems"
        :random-attachment="randomAttachment"
        :supports="{
          multiSelect: true,
          collections: true,
          randomAttachment: true
        }"
        :loading="loading"
        @setPage="page = $event"
      />
    </v-container>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"
import dayjs from "dayjs"
import FileUpload from "../components/FileUpload"
import GalleryNext from "../components/Gallery"
const advancedFormat = require("dayjs/plugin/advancedFormat")
dayjs.extend(advancedFormat)
export default {
  name: "Gallery",
  components: {
    FileUpload,
    GalleryNext
  },
  data() {
    return {
      selected: [],
      uploadDialog: false,
      pulse: {
        timeOnPage: 0,
        timeOnGalleryPage: 0
      },
      items: {
        items: [],
        pager: []
      },
      show: {
        metadata: true,
        selected: "all",
        search: "",
        types: [
          {
            name: "All of them",
            internalName: "all"
          },
          {
            name: "Not collectivized",
            internalName: "nonCollectivized"
          },
          {
            name: "Images",
            internalName: "image"
          },
          {
            name: "Videos",
            internalName: "video"
          },
          {
            name: "Audio",
            internalName: "audio"
          },
          {
            name: "Text",
            internalName: "text"
          },
          {
            name: "Pastes",
            internalName: "paste"
          },
          {
            name: "Other",
            internalName: "binary"
          }
        ]
      },
      loading: false,
      page: 1,
      uploadProgress: 0
    }
  },
  computed: {},
  methods: {
    setPage(event) {
      this.page = parseInt(event.target.value)
    },
    randomAttachment() {
      this.axios.get("/api/v1/userutils/randomAttachment").then((res) => {
        if (this.$store.state.user.openGraph) {
          navigator.clipboard.writeText(
            "https://" +
              this.$store.state.user.domain.domain +
              this.$store.state.user.customPath +
              res.data.attachment
          )
        } else {
          navigator.clipboard.writeText(
            "https://" +
              this.$store.state.user.domain.domain +
              "/i/" +
              res.data.attachment
          )
        }
      })
    },
    processUpload(files) {
      console.log(files)
      const data = new FormData()
      for (let i = 0; i < files.length; i++) {
        data.append("attachments", files[i])
      }
      this.axios
        .post("/api/v1/gallery/upload/site", data, {
          onUploadProgress: (progressEvent) => {
            this.uploadProgress = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            )
          }
        })
        .then(() => {
          this.uploadProgress = 0
          this.uploadDialog = false
          this.getItems(true)
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    search() {},
    dayjs(params) {
      return dayjs(params)
    },
    copyLink(item) {
      if (this.$store.state.user.openGraph) {
        navigator.clipboard.writeText(
          "https://" +
            this.$store.state.user.domain.domain +
            this.$store.state.user.customPath +
            item.attachment
        )
      } else {
        navigator.clipboard.writeText(
          "https://" +
            this.$store.state.user.domain.domain +
            "/i/" +
            item.attachment
        )
      }
    },
    getItems(init, resetPage, noLoad) {
      if (resetPage) {
        this.page = 1
      }
      if (!noLoad) {
        this.loading = true
      }
      this.axios
        .get(
          "/api/v1/gallery/personal/" +
            this.page +
            "?filter=" +
            this.show.selected +
            "&search=" +
            this.show.search +
            "&textMetadata=" +
            this.show.metadata +
            "&itemsPerPage=" +
            this.$store.state.attributes.experience.itemsPerPage
        )
        .then((res) => {
          this.items = res.data
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    doSinglePulse(type, other, timeOnPage) {
      this.$socket.emit("pulse", {
        action: type,
        timeSpent: timeOnPage || 0,
        route: this.$route.path,
        device: navigator.device,
        sysInfo: {
          ua: navigator.userAgent
        },
        name: null,
        other
      })
    }
  },
  async mounted() {
    this.page = parseInt(this.$route.params.page)
    this.getItems(true, false)
  },
  watch: {
    page() {
      this.getItems(true, false)
      this.$router.push("/gallery/" + this.page)
      this.doSinglePulse(
        "gallery-page-change",
        {
          page: this.page
        },
        this.pulse.timeOnGalleryPage
      )
      this.pulse.timeOnGalleryPage = 0
    }
  }
}
</script>

<style scoped></style>
